#import '../../fragments/userProfile.fragment.graphql'

mutation loginMutation($user: String!, $password: String!, $type: String!) {
  login(input: { user: $user, password: $password, type: $type }) {
    result {
      success
      token
      message
    }
    profile {
      ...UserProfileFragment
    }
  }
}
